import React from 'react';
import { BrowserRouter, Switch, Route } from 'react-router-dom';
import RoutesPath from '../constants/routes-path';

import HomePage from '../pages/Home';
import NewTicketPage from '../pages/NewTicket';
import TicketPage from '../pages/Ticket';

import Analytics from './Analytics';
import Test from '../pages/Home/Test';
import PluginIframePage from '../pages/Home/PluginIframePage';
import SideNav from '../components/Sidenav';
import WelcomePage from '../pages/WelcomePage/WelcomePage';

const Routes = () => (
    <BrowserRouter>
        <Analytics>
            <div className="flex" style={{ height: "100vh", width: "100vw" }}>
                <SideNav />

                <div className="flex-1" style={{ flex: 1 }}>
                    <Switch>
                        <Route exact path={"/"} component={WelcomePage} />
                        <Route exact path={"/home"} component={HomePage} />

                        <Route exact path={"/plugin"} component={PluginIframePage} />
                        <Route exact path={"/iframe"} component={PluginIframePage} />
                    </Switch>
                </div>
            </div>
        </Analytics>
    </BrowserRouter>
);

export default Routes;
